import { useContext } from 'react';
import { IDonorSearchResult } from '@nkr/models/index';
import { withBaseIcon } from 'react-icons-kit';
import { chevronCircleRight } from 'react-icons-kit/fa/chevronCircleRight';
import { Alert, Button, Glyphicon } from 'react-bootstrap';
import { DonorSearchContext } from './context';
import { ClosedLoopAssignType } from '@nkr/enums/index';
import SectionButton from './section-button';

const SideIconContainer =
    withBaseIcon({ size: 32, style: { color: '#123' } })

interface IProps {
    data: IDonorSearchResult,
    isInDonorShield: boolean
}

const Workflow = (props: IProps) => {
    const context = useContext(DonorSearchContext);

    const handleFindDash = () => {
        context.doDisplayDashSearch();
    };

    const handleCreateDash = () => {
        context.doDisplayCreate(ClosedLoopAssignType.DASH);
    };

    const handleFindDonor = () => {
        context.doDisplayFindDonor();
    };

    const handleCreateDonor = () => {
        context.doDisplayCreate(ClosedLoopAssignType.Donor);
    };

    const handleFindDsd = () => {
        context.doDisplayFindDsd();
    };

    const handleCreateDsd = () => {
        context.doDisplayCreate(ClosedLoopAssignType.DonorShieldDirect);
    };

    const handleCreateWatr = () => {
        context.doDisplayCreate(ClosedLoopAssignType.WaTR);
    };

    const handleCreateDonorFollowUp = () => {
        context.doDisplayCreate(ClosedLoopAssignType.FollowUp);
    };

    const handleMarkDonated = () => {
        context.doMarkDonated(props.data.identifier);
    };

    const item = props.data;

    return (
        <>
            {item.registrationId == 0 && (
                <Alert style={{ backgroundColor: '#F4BC69', color: '#133666' }}>No DASH registration found. For the best timeline reporting, you may wish to find or create a registration entry</Alert>
            )}

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <SectionButton section='DASH' exists={item.registrationId > 0}>
                    <div><strong> DASH<br />Registration</strong></div>

                    {item.microsite != null && (
                        <div><a href={`/center/${context.centerId}/reports/dash-board/patient-donors?firstName=${item.microsite.firstName}&lastName=${item.microsite.lastName}&recipientId=${item.microsite.id}&recipientSearch=1`} target='_blank'>(from a microsite)</a></div>
                    )}

                    {item.registrationId == 0 && (
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                            <Button bsSize="xs" bsStyle="link" style={{ marginRight: 5 }} onClick={handleFindDash}><Glyphicon glyph='search' style={{ marginRight: 5 }} />Find</Button>
                            <Button bsSize="xs" bsStyle="link" onClick={handleCreateDash}><Glyphicon glyph='plus' style={{ marginRight: 5 }} />Create</Button>
                        </div>
                    )}

                    {item.registrationId > 0 && (
                        <Button bsSize="xs" bsStyle="link" style={{ marginTop: 5 }} href={`/center/${context.centerId}/donors/donor-intake/details/${item.registrationId}`} target='_blank'><Glyphicon glyph='plus' style={{ marginRight: 5 }} />Details</Button>
                    )}
                </SectionButton>

                <div style={{ display: 'flex', justifyContent: 'center', marginLeft: 20, marginRight: 20 }}>
                    <SideIconContainer icon={chevronCircleRight} />
                </div>

                {props.isInDonorShield ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #a1a1a1', padding: 30, borderRadius: 8 }}>
                        <SectionButton section='SWAP-DONOR' exists={item.donorId > 0}>
                            <div><strong>NKR<br />Swap Donor</strong></div>

                            {item.donorShieldDirectId == 0 && item.donorId == 0 && (
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                                    <Button bsSize="xs" bsStyle="link" style={{ marginRight: 5 }} onClick={handleFindDonor}><Glyphicon glyph='search' style={{ marginRight: 5 }} />Find</Button>
                                    <Button bsSize="xs" bsStyle="link" onClick={handleCreateDonor}><Glyphicon glyph='plus' style={{ marginRight: 5 }} />Create</Button>
                                </div>
                            )}

                            {item.donorId > 0 && (
                                <Button bsSize="xs" bsStyle="link" style={{ marginTop: 5 }} href={'/center/' + context.centerId + '/donor/' + props.data.donorId + '/profile'}><Glyphicon glyph='plus' style={{ marginRight: 5 }} target='_blank' />Edit</Button>
                            )}
                        </SectionButton>

                        <div style={{ marginLeft: 20, marginRight: 20 }}>or</div>

                        <SectionButton section='DSD' exists={item.donorShieldDirectId > 0}>
                            <div><strong>Donor Shield<br />Direct</strong></div>

                            {item.donorId == 0 && item.donorShieldDirectId == 0 && (
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                                    <Button bsSize="xs" bsStyle="link" style={{ marginRight: 5 }} onClick={handleFindDsd}><Glyphicon glyph='search' style={{ marginRight: 5 }} />Find</Button>
                                    <Button bsSize="xs" bsStyle="link" onClick={handleCreateDsd}><Glyphicon glyph='plus' style={{ marginRight: 5 }} />Create</Button>
                                </div>
                            )}

                            {item.donorShieldDirectId > 0 && (
                                <Button bsSize="xs" bsStyle="link" style={{ marginTop: 5 }} href={`center/${context.centerId}/donors/donor-shield-direct/edit-donor/${props.data.donorShieldDirectId}`} target='_blank'><Glyphicon glyph='plus' style={{ marginRight: 5 }} />Edit</Button>
                            )}
                        </SectionButton>
                    </div>
                    :
                    <SectionButton section='SWAP-DONOR' exists={item.donorId > 0}>
                        <div><strong>NKR<br />Swap Donor</strong></div>

                        {item.donorShieldDirectId == 0 && item.donorId == 0 && (
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                                <Button bsSize="xs" bsStyle="link" style={{ marginRight: 5 }} onClick={handleFindDonor}><Glyphicon glyph='search' style={{ marginRight: 5 }} />Find</Button>
                                <Button bsSize="xs" bsStyle="link" onClick={handleCreateDonor}><Glyphicon glyph='plus' style={{ marginRight: 5 }} />Create</Button>
                            </div>
                        )}

                        {item.donorId > 0 && (
                            <Button bsSize="xs" bsStyle="link" style={{ marginTop: 5 }} href={'/center/' + context.centerId + '/donor/' + props.data.donorId + '/profile'} target='_blank'><Glyphicon glyph='plus' style={{ marginRight: 5 }} />Edit</Button>
                        )}
                    </SectionButton>
                }

                <div style={{ display: 'flex', justifyContent: 'center', marginLeft: 20, marginRight: 20 }}>
                    <SideIconContainer icon={chevronCircleRight} />
                </div>

                <SectionButton section='WATR' exists={item.watrRequestId > 0}>
                    <div><strong>Wage &amp; Expenses<br />Reimbursement</strong></div>

                    {item.watrRequestId == 0 && item.donationDate != '' && (
                        <Button bsSize="xs" bsStyle="link" style={{ marginTop: 5 }} onClick={handleCreateWatr}><Glyphicon glyph='plus' style={{ marginRight: 5 }} />Create</Button>
                    )}

                    {item.watrRequestId > 0 && (
                        <Button bsSize="xs" bsStyle="link" style={{ marginTop: 5 }} href={`/center/${context.centerId}/donors/watr`} target='_blank'><Glyphicon glyph='plus' style={{ marginRight: 5 }} />Edit</Button>
                    )}
                </SectionButton>

                <div style={{ display: 'flex', justifyContent: 'center', marginLeft: 20, marginRight: 20 }}>
                    <SideIconContainer icon={chevronCircleRight} />
                </div>

                <SectionButton section='DFUP' exists={item.followUpDonorId > 0}>
                    <div><strong>Donor<br />Follow-Up</strong></div>

                    {item.followUpDonorId == 0 && (
                        <Button bsSize="xs" bsStyle="link" style={{ marginTop: 5 }} onClick={handleCreateDonorFollowUp}><Glyphicon glyph='plus' style={{ marginRight: 5 }} />Create</Button>
                    )}

                    {item.followUpDonorId > 0 && (
                        <Button bsSize="xs" bsStyle="link" style={{ marginTop: 5 }} href={`/center/${context.centerId}/follow-up/donor/${props.data.followUpDonorId}`} target='_blank'><Glyphicon glyph='plus' style={{ marginRight: 5 }} />Edit</Button>
                    )}
                </SectionButton>

                <div style={{ display: 'flex', justifyContent: 'center', marginLeft: 20, marginRight: 20 }}>
                    <SideIconContainer icon={chevronCircleRight} />
                </div>

                <SectionButton section='DFUP' exists={false}>
                    {item.closeLoopSurgeryDateTime != null ?
                        <div style={{ fontSize: 12 }}>
                            <div><strong>Donated</strong></div>
                            <div>{item.closeLoopSurgeryDateTime}</div>
                            <div><strong>Confirmed By</strong></div>

                            {item.closeLoopEntityTypeId == 5 ?
                                <div>{item.closeLoopManualConfirmType}</div>
                                :
                                <div>{item.closeLoopEntityType}</div>
                            }
                        </div>
                        :
                        <>
                            {item.registrationId > 0 ?
                                <div><Button bsStyle='primary' bsSize='sm' onClick={handleMarkDonated}>Mark as Donated</Button></div>
                                :
                                <>To close the loop,<br />assign or create a DASH registration</>
                            }
                        </>
                    }
                </SectionButton>
            </div>
        </>
    );
}

export default Workflow;